import { idFromEntityId } from 'helpers/common';
import { IOffice } from 'models/shop/office';
import { IStore } from 'redux/IStore';

export const getStaff = (state: IStore, officeId: string) => {
	if (!state.manageShop?.shop?.offices?.length || !officeId) {
		return null;
	}
	const office = getOffice(state, officeId);
	if (!office) {
		console.warn('Invalid office ID chosen', officeId);
		return null;
	}
	return office.staff || [];
};

export const getStaffMember = (state: IStore, officeId: string, memberId: string) => {
	if (!memberId) {
		return undefined;
	}
	const staff = getStaff(state, officeId) || [];
	return staff.find((s) => s.id === memberId || s.id === idFromEntityId(memberId));
};

export const getOffice = (state: IStore, officeId?: string): IOffice | undefined => {
	if (!officeId) {
		return undefined;
	}
	return (state.manageShop?.shop?.offices || []).find((o) => o.id === officeId);
};

export const arePropArraysEqual = (arr1, arr2) => {
	if (!arr1 || !arr2) {
		return false;
	}

	if (arr1.length !== arr2.length) {
		return false;
	}

	const sortedArr1 = arr1.slice().sort();
	const sortedArr2 = arr2.slice().sort();

	for (let i = 0; i < sortedArr1.length; i++) {
		if (sortedArr1[i] !== sortedArr2[i]) {
			return false;
		}
	}

	return true;
};
